
app.service('dispatcher', function (captchaService, cartRetrieve, reportBug, simpleToastr, lazyLoad, regulations,
	operator, partnerBar, energyLabel, dataSeoUrl, simpleModal, console, html, combobox, stickyHeader, goBack, focusTrap,
	tooltip, log, front, broker, holidayPromotion, select, relatedPromotionCommercial, durabilityGuaranteeLayer) {

	function run() {
		// skrypty uruchamiane po wymianie strony, po każdym zaciągnięciu strony ajaxowo
		$('.order-path-'+(html.has('new-delivery') ? 'old' : 'new')).remove();
		setViewMode();
		select.resetElements();
		captchaService.init();
		log.visit();
		stickyHeader.init();
		operator.init();
		combobox.init();
		tooltip.init();
		wdioRandom();
	}
	let isOneInit = false;
	function init() {
		if (!isOneInit) {
			isOneInit = true;
			//--------   tutaj zweryfikowane jednokrotnie wywołane
			select.init();
			reportBug.init();
			simpleModal.init();
			simpleToastr.init();
			lazyLoad.init();
			holidayPromotion.init();
			relatedPromotionCommercial.init();
			energyLabel.init();
			durabilityGuaranteeLayer.init();
			dataSeoUrl.init();
			cartRetrieve.init();
			partnerBar.init();
			focusTrap.init();
			broker.on('PAGE_CHANGE', function () {
				run()
			});
			$('body').on('click', '.js-regulations', function (event) {
				regulations.show();
				event.preventDefault();
				event.stopPropagation();
			}).on('click', '[href="#"]', function (event) {
				event.preventDefault();
			}).on('click', '.checkbox-css p.less a.show-more, .checkbox-css p.more a.show-less', function () {
				$(this).closest('.checkbox-css').toggleClass('checkbox-css-more');
			}).on('paste keyup change', 'textarea[maxlength]', function () {
				$('.char-counter-current', $(this).parent()).text($(this).val().length);
			}).on('click', '.js-toogle-password-type', function () {
				let $this = $(this);
				let $input = $this.prev()
				if ($input.attr('type') == 'password') {
					$input.attr('type', 'text');
					$this.text($this.data('hide'));
				} else {
					$input.attr('type', 'password');
					$this.text($this.data('show'));
				}
			}).on('click', '.js-print', function () {
				window.print();
			}).on('click', '.js-native-app-back-button', function () {
				goBack.overlayBackOrClose();
			}).on('keyup', 'input[name*="companyName"]', function () {			// gdy pierwsze pole firma osiągnie swój limit zostaje przeniesione do drugiego pola
				var $this = $(this);
				if ($(this).val().length == $(this).attr('maxlength')) {
					let name = $this.attr('name');
					let newName = name.replace("Part1", "Part2");
					if (newName != name) {
						let $cont = $('input[name="' + newName + '"]');
						if ($cont.length) {
							console.log('osiągnięto limit w pierwszym polu firma, przeskok do pola: ' + newName);
							$cont.click().click().focus();
						}
					}
				}
			}).on('keyup', 'div[tabindex=0], div[role=button], div[role=radio], span[tabindex=0], label.radio-css, label.checkbox-css', function (event) {
				if (['Enter', 'NumpadEnter', 'Space'].includes(event.code)) {
					if ($(event.target).is('div[tabindex=0], div[role=button], div[role=radio], span[tabindex=0], label.radio-css, label.checkbox-css')) {
						console.log('Wymuszenie klika na elemencie');
						$(this)[0].click();
					}
				}
			}).on('keydown', 'div[tabindex=0], div[role=button], div[role=radio], span[tabindex=0], label.radio-css, label.checkbox-css', function (event) {
				if (['Enter', 'NumpadEnter', 'Space'].includes(event.code) && html.has('keyboard-focusing')) {
					event.preventDefault();
					event.stopPropagation();
				}
			}).on('keydown', function (event) {
				if (event.key === 'Tab') {
					html.add('keyboard-focusing');
				}
			}).on('click', 'input', function (event) {
				html.remove('keyboard-focusing');
			});
			window.addEventListener('resize', function () {
				setViewMode();
			});

			broker.on('WDIO-PAGE-REFRESH', function () {
				wdioRandom();
			});
			run();
		}
	}
	function wdioRandom() {
		$('body').attr('wdio-random', parseInt(Math.random() * 100000000));
	}
	function setViewMode() {
		let $viewMode = $('#view-mode');
		if ($viewMode.length) {
			$viewMode.val(front.getBrakepoint());
		} else {
			let $form = $('body form').first();
			if ($form.length) {
				$form.prepend('<input type="hidden" id="view-mode" name="viewMode" value="" />');
				setViewMode();
			}
		}
	};
	return {
		init
	}
});
